export const API_BASE_URL = import.meta.env.VITE_SERVER_URL;
export const GET_CAPTIONS = "getCaptions";
export const supportEmail = "support@subtitles.tech";
export const TRANSCRIPT_YOUTUBE = "transcriptYoutubeVideo";
export const TRANSLATE_CAPTIONS = "translateCaptions";
export const TRANSLATE_TEXT = "translateText";
export const TRANSLATE_TEXT_BULK = "translateTextBulk";
export const TRANSLATE_TEXT_WITH_CONTEXT = "translateTextWithContext";
export const TRANSLATE_TEXT_BULK_WITH_CONTEXT = "translateTextBulkWithContext";
export const TRANSLATE_CAPTIONS_WITH_CONTEXT = "translateCaptionsWithContext";
export const TRANSLATE_TEXT_GPT = "translateTextGPT";
export const TRANSLATE_TEXT_BULK_GPT = "translateTextBulkGPT";
export const TRANSCRIPT_AUDIO = "transcriptAudioFile";
export const TRANSCRIPT_AUDIO_SONIOX = "transcriptAudioFileSoniox";
export const SIGNIN = "signin";
export const SIGNUP = "signup";
export const LOGOUT = "logout";
export const CHECKTOKEN = "checkToken";
export const GETOTP = "getResetOtp";
export const CHECKOTP = "checkOtp";
export const RESETPASS = "resetPassword";
export const GETNOTIFICATION = "userNotification";
export const CREATECHECKOUT = "createCheckoutSession";
export const GETBALANCE = "getBalance";
export const GETTRANSAUDIOFILE = "getTranscriptionFile";
export const SECCESSORDER = "successOrder";
export const GETPRICES = "getPrices";
export const USERPROFILE = "userProfile";
export const ORDERSHISTORY = "ordersHistory";
export const UPDATEPASSWORD = "updatePassword";
export const YTVIDEOLANGUAGE = "getVideoLanguage";
export const TRANSCRIPTEXTERNVIDEO = "transcriptVideoLink";
export const TRANSCRIPTEXTERNAUDIO = "transcriptAudioLink";
export const UPDATEEMAIL = "updateEmail";
export const SUPPORTMESSAGES = "supportMessages";
export const PAYMENTSHISTORY = "paymentsHistory";
export const GETCLIENTCOUNTRY = "getClientCountry";
export const GETTRANSLATEDTEXT = "getTranslatedText";
export const GOOGLEAUTH = "googleAuth";
export const GOOGLEDRIVEVIDEO = "transcriptGdriveVideoLink";
export const GOOGLEDRIVEAUDIO = "transcriptGdriveAudioLink";
export const SPEAKTEXT = "speakText";
export const VERIFYEMAIL = "verifyEmail";
export const RESENDVERIFICATION = "resendEmailVerification";
export const GETSUBSCRIPTION = "getSubscription";
export const CANCELSUBSCRIPTION = "cancelSubscription";
export const MARKALLSEEN = "markAllSeen";
export const USERPROFILEPICTURE = "userProfilePicture";
export const CREATECHECKOUTPAYPAL = "createPaypalCheckout";
export const CREATESUBSPAYPAL = "createPaypalSubscription";
export const SETACTIVEPAYMENT = "setActivePayment";
export const CAPTUREPAYPALORDER = "capturePaypalOrder";
export const GENERATEUPLOADURL = "generateUploadUrl";
export const SUMMARIZETEXT = "summarizeText";
export const DUBBINGTEXT = "dubbingText";
export const BUYWITHBALANCE = "buyWithBalance";
export const STREAMTEXT = "streamText";
export const GETGOOGLEFONTS = "getGoogleFonts";
export const PRODUCTIONFRONTEND = "https://subtitles-web-docker-2-950681876295.us-central1.run.app/";

export const ONETIME_AUDIO_PRICING = "oneTimeAudio/pricing";
export const ONETIME_AUDIO_YOUTUBE_PRICING = "oneTimeAudio/youtubePricing";
export const ONETIME_AUDIO_CREATE_ORDER = "oneTimeAudio/createOrder";
export const ONETIME_AUDIO_UPLOAD_URL = "oneTimeAudio/uploadUrl";
export const ONETIME_AUDIO_CONFIRM_UPLOAD = "oneTimeAudio/confirmUpload";
export const ONETIME_AUDIO_CONFIRM_VIDEO_LINK = "oneTimeAudio/confirmVideoLink";
export const ONETIME_AUDIO_CONFIRM_AUDIO_LINK = "oneTimeAudio/confirmAudioLink";
export const ONETIME_AUDIO_RESULT = "oneTimeAudio/result";